import { phone as parsePhoneNumber } from "phone";

/**
 * Regular Expressions to validate string patters
 * Names should have only alphabets and spaces in between
 * EmailID should be in valid email format
 */
const nameRegex = /^[a-z ]*[a-z]$/i;
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validEmail = (emailId) => {
  return emailId && emailRegex.test(String(emailId));
};

export const validName = (name) => {
  return name && nameRegex.test(String(name));
};

/**
 * Validate a phone number against the country selected in the phone field.
 *
 * The `react-phone-input-2` widget emits the number as dial-code-prefixed
 * digits with no leading "+" (e.g. Qatar → "97433049207") and its country
 * object carries the ISO 3166-1 alpha-2 code (e.g. "qa"). Passing that country
 * to the `phone` library lets it accept the number whether it was typed as the
 * national part, as dial-code digits, as "+974…", or with the "00" international
 * access prefix — and it works for EVERY country, including the many the widget
 * has no fixed-length mask for (Qatar, UAE, …). The previous approach compared
 * the typed length against the widget's mask, so any maskless country fell back
 * to an over-long generic mask a real number could never fill, and every such
 * number was wrongly rejected.
 *
 * @param {string} phoneNumber - the number as entered, in any format
 * @param {string} countryIso2 - ISO alpha-2 code from the phone field (e.g. "in")
 * @returns {boolean} whether it is a valid number for that country
 */
export const isValidPhoneNumber = (phoneNumber, countryIso2) => {
  if (!phoneNumber) {
    return false;
  }
  const { isValid } = parsePhoneNumber(phoneNumber, {
    country: countryIso2 ? String(countryIso2).toUpperCase() : undefined,
  });
  return isValid;
};
